import React from 'react';
import Alignment from "./widgets/AlignmentWidget.js";
export default {
  matches: {
    use: 'MenuBar',
    client: 'CustomTextModelEditor'
  },
  id: 'Rich.Text.Editor.Alignment',
  handles: () => true,
  layout: {
    sort: 'K'
  },
  customComponent: props => {
    return /*#__PURE__*/React.createElement(Alignment, {
      ...props,
      onChange: (value, editor) => {
        if (value && value?.length) {
          editor.chain().focus().setTextAlign(value).run();
        }
      }
    });
  }
};